<script lang="ts">
    import { BackgroundService } from "$/services/BackgroundService";
    import { DocumentService } from "$/services/DocumentService";
    import { ServiceConsts } from "$/services/ServiceConsts";
    import { clickAction } from "$/utils/clickAction";
    import { getURLFileName } from "$/utils/upload";

    let pdfLoading = false;
    let pdfTooBig = false;

    const DocumentServiceImpl = chrome?.storage
        ? BackgroundService
        : DocumentService;

    const openPDFViewer = async () => {
        if (pdfLoading || pdfTooBig) return;

        pdfLoading = true;

        let pdfUrl = document.location.href;

        let publicPdfExists =
            await DocumentServiceImpl.checkPDFExistence(pdfUrl);

        if (!publicPdfExists) {
            await uploadPdfFromUrl(pdfUrl);
        }

        if (!pdfTooBig) {
            let fullUrl = btoa(pdfUrl) + "/" + getURLFileName(pdfUrl);
            let url = encodeURIComponent(
                ServiceConsts.PUBLIC_PDF_URL + "pdf/" + encodeURI(fullUrl),
            );
            window.open(`${ServiceConsts.DASHBOARD_URL}/pdf/${url}/`, "_blank");
            pdfLoading = false;
        }
    };

    const uploadPdfFromUrl = async (url) => {
        try {
            const response = await fetch(url);
            const pdfBlob = await response.blob();
            const fileName = getURLFileName(url);
            const file = new File([pdfBlob], fileName, {
                type: "application/pdf",
            });

            if (file.size > 30 * 1024 * 1024) {
                pdfTooBig = true;
                pdfLoading = false;
            } else {
                await DocumentServiceImpl.uploadPublicPDF(file, url);
            }
        } catch (error) {
            console.error("Error fetching PDF:", error);
        }
    };
</script>

<div
    class={pdfLoading || pdfTooBig
        ? "cw-open-pdf cw-open-pdf--disabled"
        : "cw-open-pdf"}
    use:clickAction={openPDFViewer}
>
    <svg
        class={pdfLoading || pdfTooBig
            ? "cw-open-pdf--disabled__icon"
            : "cw-open-pdf__icon"}
        width="1000"
        height="1000"
        viewBox="0 0 1000 1000"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M316.792 474.54C328.558 474.54 338.7 478.035 347.22 485.024C355.74 491.601 360 500.235 360 510.924C360 516.268 358.58 523.051 355.74 531.274C353.306 539.496 350.06 546.896 346.003 553.474C331.398 578.551 312.938 597.051 290.624 608.974C268.31 620.896 240.722 626.857 207.86 626.857C170.129 626.857 137.267 617.607 109.273 599.107C81.2791 580.607 59.7766 554.296 44.7654 520.174C30.1599 486.051 22.8572 446.379 22.8572 401.157C22.8572 356.346 30.1599 317.496 44.7654 284.607C59.3708 251.718 80.4676 226.64 108.056 209.374C136.05 191.696 169.52 182.857 208.468 182.857C236.868 182.857 262.63 187.585 285.756 197.04C308.881 206.085 326.935 218.829 339.918 235.274C353.306 251.307 360 269.396 360 289.54C360 307.629 354.523 322.429 343.569 333.94C333.021 345.451 319.226 351.207 302.187 351.207C284.741 351.207 270.744 346.479 260.196 337.024C249.648 327.157 244.373 314.207 244.373 298.174C244.373 289.54 245.996 281.318 249.242 273.507C240.316 267.751 227.334 264.874 210.294 264.874C179.055 264.874 156.538 275.768 142.744 297.557C128.95 318.935 122.053 352.851 122.053 399.307C122.053 447.818 129.558 484.201 144.569 508.457C159.581 532.712 182.909 544.84 214.554 544.84C229.565 544.84 242.142 541.551 252.285 534.974C262.427 527.985 271.15 517.296 278.453 502.907C283.727 491.807 289.001 484.407 294.275 480.707C299.955 476.596 307.461 474.54 316.792 474.54Z"
            fill="currentColor"
        />
        <path
            d="M948.023 390.441C956.92 390.441 963.998 392.676 969.256 397.147C974.514 401.21 977.143 407.916 977.143 417.263V444.084C977.143 453.431 974.514 460.339 969.256 464.809C963.998 469.279 956.92 471.515 948.023 471.515H938.922L853.382 795.807C851.764 802.31 848.124 807.593 842.461 811.656C836.799 815.314 830.53 817.143 823.654 817.143H776.334C769.054 817.143 762.583 815.314 756.92 811.656C751.663 807.593 748.023 802.31 746 795.807L677.446 578.19L608.892 795.807C606.87 802.31 603.028 807.593 597.365 811.656C591.703 815.314 585.232 817.143 577.952 817.143H530.025C523.149 817.143 516.88 815.314 511.218 811.656C505.555 807.593 501.915 802.31 500.298 795.807L414.757 471.515H405.657C397.163 471.515 390.287 469.279 385.03 464.809C379.772 460.339 377.143 453.431 377.143 444.084V417.263C377.143 407.916 379.772 401.21 385.03 397.147C390.287 392.676 397.163 390.441 405.657 390.441H522.745C531.238 390.441 538.114 392.676 543.371 397.147C548.629 401.21 551.258 407.916 551.258 417.263V444.084C551.258 453.431 548.629 460.339 543.371 464.809C538.114 469.279 531.238 471.515 522.745 471.515H513.644L566.425 679.989L631.946 473.343C633.968 466.841 637.406 461.761 642.259 458.104C647.113 454.04 652.775 452.008 659.246 452.008H713.24C719.307 452.008 724.767 454.04 729.62 458.104C734.474 461.761 737.911 466.841 739.934 473.343L804.848 677.55L857.022 471.515H847.921C839.024 471.515 831.946 469.279 826.688 464.809C821.43 460.339 818.801 453.431 818.801 444.084V417.263C818.801 407.916 821.43 401.21 826.688 397.147C831.946 392.676 839.024 390.441 847.921 390.441H948.023Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M398.847 183.742C383.907 186.295 369.059 178.757 362.337 165.205L359.702 159.892C354.911 150.234 354.966 138.889 359.85 129.278C364.733 119.667 373.874 112.914 384.515 111.057C415.335 105.677 447.234 102.857 479.878 102.857C631.685 102.857 768.035 163.925 854.192 260.542C862.672 270.051 865.154 283.471 860.634 295.373C856.114 307.274 845.34 315.686 832.671 317.205L825.714 318.039C814.693 319.361 803.713 315.277 796.25 307.081C725.197 229.05 610.964 176.929 479.878 176.929C452.047 176.929 424.949 179.282 398.847 183.742Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M280.938 785.327L298.985 786.69C302.421 786.95 305.799 787.725 309.004 788.99C335.298 799.364 363.266 807.436 392.535 812.852C395.129 813.332 397.659 814.109 400.074 815.167L420.962 824.324C436.635 831.194 444.823 848.546 440.14 864.971C435.458 881.396 419.343 891.856 402.389 889.474C353.558 882.613 319.519 874.238 276.907 855.594C276.907 845.5 280.938 801 280.938 785.327Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M127.988 684.987C146.393 689.403 157.725 707.864 153.297 726.222C141.821 773.807 129.625 811.05 120.81 837.968C119.89 840.779 119.006 843.479 118.163 846.065C133.4 840.208 151.653 832.66 174.311 823.291C198.239 813.395 227.079 801.469 262.468 787.358C280.938 785.327 280.938 785.327 280.938 785.327C280.938 801 276.907 845.5 276.907 855.594C241.658 869.65 221.687 877.78 195.88 888.507C173.978 897.611 155.803 905.166 141.908 910.577C126.281 916.663 112.084 921.688 100.342 924.063C94.4674 925.252 87.0432 926.252 79.2467 925.39C70.973 924.475 60.24 921.171 51.6286 911.875C43.286 902.87 40.8403 892.424 40.2085 885.129C39.588 877.964 40.4552 871.1 41.4597 865.63C41.9381 863.025 42.5377 860.289 43.2334 857.448C45.4463 848.122 48.7514 837.623 52.2302 826.892C53.437 823.17 54.7123 819.28 56.0452 815.214C64.7971 788.515 76.0303 754.248 86.6459 710.231C91.0732 691.873 109.583 680.571 127.988 684.987Z"
            fill="currentColor"
        />
    </svg>
    {#if pdfLoading}
        <span class="text-with-icon"
            >Opening PDF
            <span class="button-spinner">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="h-6 w-6"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                </svg>
            </span>
        </span>
    {:else if pdfTooBig && !pdfLoading}
        <span>File too big. Max size is 30MB.</span>
    {:else}
        <span class="cw-open-pdf__text">Open in Collabwriting</span>
    {/if}
</div>

<style>
    .cw-open-pdf {
        @apply reset fixed bottom-8 right-8 z-[2100000001] box-border flex h-12 cursor-pointer select-none items-center justify-center rounded-full bg-pink-500 px-4 py-2 shadow-2xl transition-all hover:scale-105 hover:bg-pink-700 !important;
    }

    .cw-open-pdf--disabled {
        @apply pointer-events-none cursor-not-allowed bg-neutral-200 text-gray-400 shadow-sm transition-all hover:scale-105 hover:bg-neutral-300 hover:text-gray-500 hover:shadow-md !important;
    }

    .cw-open-pdf__icon {
        @apply reset mr-2 h-6 w-6 text-white !important;
    }

    .cw-open-pdf--disabled__icon {
        @apply reset mr-2 h-6 w-6 text-gray-400 !important;
    }

    .cw-open-pdf__text {
        @apply reset text-sm text-white !important;
    }

    .button-spinner {
        @apply relative left-1 top-0 animate-spin !important;
    }

    .text-with-icon {
        @apply flex flex-row items-center !important;
    }
</style>
